import {
  ColumnHeaderMultiSelectFilter,
  UpdateFilterType,
} from "../../ReusableHeaderFilter/ColumnHeaderMultiSelectFilter";
import React from "react";
import { Task1120TrackerFilterType } from "../Task1120TrackerFilter";
import {
  useGetAgentAvailabilityQuery,
  useGetAssignAgentsQuery,
} from "store/apis/agents";
import { FILTER_AGENT, UNASSIGNED_OPTION } from "../Task1120FilterOptions";
import { useRoleBasedView } from "hooks/useRoleBasedView";

export const AssignAgentColumnHeader = ({
  values,
  updateFilter,
}: Omit<Task1120TrackerFilterType, "updateFilter"> & {
  updateFilter: UpdateFilterType;
}) => {
  const { isAdmin } = useRoleBasedView();
  const { data: supportAgents = [] } = useGetAssignAgentsQuery(
    {},
    { skip: !isAdmin }
  );

  const updatedOptions = [
    { uuid: UNASSIGNED_OPTION, name: "Unassigned" },
    ...supportAgents,
  ];

  return (
    <div className="t-flex t-items-center t-justify-between t-w-full">
      <div>Assigned Agent</div>
      <ColumnHeaderMultiSelectFilter
        filterName={FILTER_AGENT}
        options={
          updatedOptions?.map((agent) => ({
            value: agent.uuid,
            label: agent.name,
          })) || []
        }
        selected={values.AGENT || null}
        updateFilter={updateFilter}
      />
    </div>
  );
};
